import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIMS_UPDATE_PROCESS_STATUS } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const useProcessStatus = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_CLAIMS_UPDATE_PROCESS_STATUS(), payload);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เปลี่ยนสถานะภายในสำเร็จ',
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message || 'เปลี่ยนสถานะภายในไม่สำเร็จ',
      });
    },
  });
};
